import { Navigate } from "react-router-dom";


const OtpRoute = ({ children, isAuthenticated, showReferalPage, temporaryToken, phoneNumber }) => {

    if (isAuthenticated && !showReferalPage) {
        return <Navigate to="../" replace />;
    }
    else if(showReferalPage) {
    	if(!!temporaryToken)
    		return <Navigate to="../referal" replace />;
    	else if(phoneNumber === '')
    		return <Navigate to="../login" replace />;
    }

    return children;
}

export default OtpRoute;
